import styled from 'styled-components'

const darkColor = props => props.theme.global.colors['dark-2']
const lightColor = props => props.theme.global.colors['white']
const borderColor = props => props.theme.global.colors['light-7']
const bgColor = props => props.theme.global.colors['background-back']

export const Container = styled.div`
  padding: 24px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  background-color: ${lightColor};

  > ul {
    margin: 0px 0 16px;
    padding: 0px;
    padding-left: 18px;
    font-size: 14px;
    color: ${darkColor};
    font-weight: 400;
  }

  li {
    line-height: 165%;
  }

  @media only screen and (max-width: 992px) {
    padding: 16px;
  }
`

export const FlexBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;

  @media only screen and (max-width: 992px) {
    gap: 16px;
  }
`

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const TextWrapper = styled.p`
  margin: 0 0 16px;

  span {
    font-size: 16px;
    line-height: 165%;
    font-weight: 400;
    color: ${darkColor};

    @media only screen and (max-width: 992px) {
      font-size: 14px;
    }
  }

  span:first-child {
    text-transform: uppercase;
    font-weight: 600;
  }
`

export const Quantity = styled.div`
  background-color: ${bgColor};
  border-radius: 4px;
  height: 23px;
  width: 100px;
  padding: 4px;
  text-align: center;

  > p {
    color: ${darkColor};
    font-size: 14px;
    font-weight: 600;
    line-height: 165%; 
    margin: 0;
  }

  @media only screen and (max-width: 992px) {
    width: 96px;
  }
`

export const LightText = styled.p`
  color: ${darkColor};
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  margin: 0;
`

export const ItemTotal = styled.p`
  color: ${darkColor};
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  margin: 16px 0 0;
`